"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var MessagePayloadType = /** @class */ (function () {
    function MessagePayloadType() {
    }
    MessagePayloadType.Text = "Text";
    MessagePayloadType.RichText = "RichText";
    MessagePayloadType.RichTextHtml = "RichText/Html";
    MessagePayloadType.ControlTyping = "Control/Typing";
    MessagePayloadType.ControlClearTyping = "Control/ClearTyping";
    MessagePayloadType.LiveState = "Control/LiveState";
    return MessagePayloadType;
}());
exports.default = MessagePayloadType;
//# sourceMappingURL=MessagePayloadType.js.map